let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("InrG6"), load("ex7Yl"), load("kOWvR"), load("GSVVx"), load("XfwMA")]).then(() => parcelRequire('hKxxO'));